import { render, staticRenderFns } from "./NuevaRecetaElectronica.vue?vue&type=template&id=0716506a&scoped=true"
import script from "./NuevaRecetaElectronica.vue?vue&type=script&lang=js"
export * from "./NuevaRecetaElectronica.vue?vue&type=script&lang=js"
import style0 from "./NuevaRecetaElectronica.vue?vue&type=style&index=0&id=0716506a&prod&scoped=true&lang=css"
import style1 from "./NuevaRecetaElectronica.vue?vue&type=style&index=1&id=0716506a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0716506a",
  null
  
)

export default component.exports